<script setup>
// Agents already on the team, shown as a stack that fans out when the card is
// hovered. The trailing "add" slot pulses to point at the invite action.
const AGENTS = [
  { id: 'mj', initials: 'MJ', tint: 'bg-n-iris-9' },
  { id: 'sk', initials: 'SK', tint: 'bg-n-teal-9' },
  { id: 'rd', initials: 'RD', tint: 'bg-n-amber-9' },
];
</script>

<template>
  <div class="flex items-center justify-center size-full" aria-hidden="true">
    <div class="flex">
      <span
        v-for="agent in AGENTS"
        :key="agent.id"
        class="grid text-sm font-bold text-white transition-all duration-300 border-[3px] rounded-full size-11 place-items-center border-n-background -ml-3 first:ml-0 group-hover:-ml-1 group-hover:first:ml-0"
        :class="agent.tint"
      >
        {{ agent.initials }}
      </span>
      <span
        class="relative grid text-xl transition-all duration-300 border-2 border-dashed rounded-full size-11 place-items-center bg-n-solid-1 border-n-brand text-n-brand -ml-3 group-hover:-ml-1"
      >
        +
        <span
          class="absolute border-2 rounded-full opacity-0 -inset-0.5 border-n-brand motion-safe:animate-onboarding-invite-ring"
        />
      </span>
    </div>
  </div>
</template>
